import { createAri } from '@atlassian/jira-platform-ari';

export const createBoardAri = (cloudId: string, boardId: number) =>
	createAri({
		resourceOwner: 'jira-software',
		cloudId,
		resourceType: 'board',
		resourceId: String(boardId),
	});

export const createIssueAri = (cloudId: string, issueId: number) =>
	createAri({
		resourceOwner: 'jira',
		cloudId,
		resourceType: 'issue',
		resourceId: issueId.toString(),
	});

export const createIssueAris = (cloudId: string, issueIds: number[]) =>
	issueIds.map((issueId) => createIssueAri(cloudId, issueId));
